'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.constant("datepickerDefaultConfig", {
  changeMonth: true,
  changeYear: true,
  dateFormat: "dd/mm/yy",
  yearRange: "c-35:c+35",
  // highlight the day of currently displayed month that matches the selected day, if month/year is not the same
  onChangeMonthYear: function onChangeMonthYear(y, m, i) {
    if (i.currentMonth === m - 1 && i.currentYear === y) {
      return;
    }
    var lastDayOfMonth = moment(new Date(y, m - 1, 1)).endOf("month").get("date"),
      selectedDay = Math.min(i.currentDay, lastDayOfMonth);
    _.defer(function () {
      var datePicker = i.dpDiv,
        cells = datePicker.find("table tbody td");
      var sameDateCell = cells.filter(function (i, el) {
        return $(el).find("a").text().trim() === selectedDay + "";
      });
      sameDateCell.addClass("tl-datepicker-same-date");
    });
  }
});
ngModule.directive('inputTypeDate', function ($dateDisplayFormats) {
  var validatorName = "validDateFormat";
  return {
    require: 'ngModel',
    link: function link($scope, $el, $attrs, modelCtrl) {
      $el.addClass("input-date");
      var dateFormat = $dateDisplayFormats.SHORT;
      modelCtrl.$formatters.push(function (value) {
        if (value) {
          return moment(value).format(dateFormat);
        }
        return null;
      });
      modelCtrl.$parsers.push(function (value) {
        if (!value) {
          modelCtrl.$setValidity(validatorName, true);
          return null;
        }
        if (_.isDate(value)) {
          modelCtrl.$setValidity(validatorName, true);
          return value;
        } else {
          var m = moment(value, dateFormat);
          var valid = m.isValid();
          modelCtrl.$setValidity(validatorName, valid);
          return valid ? m.toDate() : null;
        }
      });
    }
  };
});
ngModule.directive('tlDatepicker', function (datepickerDefaultConfig) {
  return {
    require: '?ngModel',
    link: function link($scope, $el, $attrs, modelCtrl) {
      // TODO : no need to extend on every watch, and no need to watch the extend result
      // also check is $attrs.uiDate exists, if not, no need to watch.

      var getOptions = function getOptions() {
        var options = angular.extend({}, datepickerDefaultConfig);
        if ($attrs.tlDatepicker) {
          angular.extend(options, $scope.$eval($attrs.tlDatepicker));
        }
        if ($attrs.datepickerDefaultDate) {
          options.defaultDate = $scope.$eval($attrs.datepickerDefaultDate);
        }
        if ($attrs.yearRange) {
          options.yearRange = $attrs.yearRange;
        }
        if ($attrs.minDate) {
          options.minDate = moment($attrs.minDate, 'YYYY/MM/DD').toDate();
        }
        if ($attrs.maxDate) {
          options.maxDate = moment($attrs.maxDate, 'YYYY/MM/DD').toDate();
        }
        return options;
      };
      var initDateWidget = function initDateWidget(options) {
        // Set the view value in a $apply block when users selects
        var _onSelect = options.onSelect || angular.noop;
        options.onSelect = function (value, picker) {
          $scope.$apply(function () {
            modelCtrl.$setViewValue(value);
            _onSelect(value, picker);
          });
          $el.trigger("blur");
        };
        $el.datepicker('destroy').datepicker(options);
      };

      // Watch for changes to the directives options
      $scope.$watch(getOptions, function (options) {
        initDateWidget(options);
      }, true);
    }
  };
});
ngModule.directive('tlDatepickerBtn', function () {
  return {
    restrict: "A",
    link: function link($scope, $el, $attrs) {
      // TODO : allow to specify an id or a selector...

      $el.click(function (event) {
        var input = $el.parent().find("input.hasDatepicker");
        if (input.length) {
          input.datepicker("show");
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/form/inputTypes/inputTypeDate.js
// module id = 2947
// module chunks = 13